import { PropertySlug } from '@mgmresorts/web-utils';

import { getPersistedParameters } from '../utils/persistParameterContext';
import { getUrlParts } from '../utils/url';

const PROPERTY_SLUG_SOURCE_MAPPER = {
  mgmresorts: 'mlife',
  empirecitycasino: 'empirecity',
  mgmgrand: 'mgmgrandlv',
  mgmnorthfieldpark: 'mgmnorthfield',
  signaturemgmgrand: 'signature',
  cosmopolitanlasvegas: 'cosmopolitanlv',
  wlasvegas: 'wlasvegas',
  nomadlasvegas: 'nomadlv',
};

export function parsePropertyFromHost(domain = 'mgmresorts', tld = 'com'): PropertySlug | undefined {
  const { property, domain: _domain, tld: _tld } = getUrlParts();

  if (domain === _domain && _tld?.startsWith(tld)) {
    return property as PropertySlug;
  }

  return undefined;
}

export const useDerivedPropertySlug = () => {
  const { domain, tld } = ['PREVIEW', 'PROD'].includes(process.env.REACT_APP_ENVIRONMENT?.toUpperCase() ?? 'DEV')
    ? {
        domain: 'mgmresorts',
        tld: 'com',
      }
    : {
        domain: 'devtest',
        tld: 'vegas',
      };

  return parsePropertyFromHost(domain, tld) ?? ('mgmresorts' as PropertySlug);
};

export const useDerivedPropertySlugAsSource = (): string => {
  const property = useDerivedPropertySlug();
  const params = getPersistedParameters();
  if (params?.source) {
    return params.source;
  }

  if (property in PROPERTY_SLUG_SOURCE_MAPPER) {
    return PROPERTY_SLUG_SOURCE_MAPPER[property];
  }
  return property;
};
